import React from "react";
import {Snackbar} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import {alertActions} from "../../../_redux/actions";
import useStyles from "./AppAlert.css"

const Alert = ((props: AlertProps) => {
    return (<MuiAlert elevation={6} variant="filled" {...props} />)
})


const AppAlert = () => {
    const classes = useStyles();
    const alertState = useSelector((state: any) => state.alert)
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(alertActions.clearAlert())
    }

    return(
        <div className={classes.root}>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={alertState.isOpen} autoHideDuration={alertState.duration} onClose={handleClose}>
                <Alert onClose={handleClose} severity={alertState.severity}>
                    {alertState.message}
                </Alert>
            </Snackbar>
        </div>
    )
}


export default AppAlert;
